import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import NewCustomer from "./pages/NewCustomer";
import Users from "./pages/Users";
import EditRequests from "./pages/EditRequests";
import Notifications from "./pages/Notifications";
import Work from "./pages/Work";
import Inspections from "./pages/Inspections";
import WarehousePortal from "./pages/WarehousePortal";
import PublicDispatch from "./pages/PublicDispatch";
import { MaterialIconsProvider } from "./lib/materialIcons";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="min-h-screen flex items-center justify-center font-mono text-sm">Loading...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  // Warehouse/dispatch team only sees the Dispatch portal
  if (user.role === "warehouse" && location.pathname !== "/") return <Navigate to="/" replace />;
  // Field Officer has nothing to do with warehouse / installation work
  if (user.role === "field_officer" && location.pathname === "/inspections") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function Home() {
  const { user } = useAuth();
  return user.role === "warehouse" ? <WarehousePortal /> : <Dashboard />;
}

function App() {
  return (
    <AuthProvider>
      <MaterialIconsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/d/:token" element={<PublicDispatch />} />
          <Route path="/" element={<Protected><Home /></Protected>} />
          <Route path="/customers" element={<Protected><Customers /></Protected>} />
          <Route path="/customers/new" element={<Protected><NewCustomer /></Protected>} />
          <Route path="/customers/:id" element={<Protected><CustomerDetail /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="/edit-requests" element={<Protected><EditRequests /></Protected>} />
          <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
          <Route path="/work" element={<Protected><Work /></Protected>} />
          <Route path="/inspections" element={<Protected><Inspections /></Protected>} />
        </Routes>
      </BrowserRouter>
      </MaterialIconsProvider>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
